const amount = value => value === '' || value === null || typeof value === 'boolean' ? NaN : Number(value);
const cents = value => Math.round((value + Number.EPSILON) * 100) / 100;
export function projectPricing(input) {
  const cost = amount(input.cost), margin = amount(input.margin), quote = amount(input.quote), scope = amount(input.scope);
  if (![cost, margin, quote, scope].every(Number.isFinite) || cost <= 0 || cost > 1e6 || quote <= 0 || quote > 1e7 || margin < 0 || margin > 95 || scope < 0 || scope > 200) return null;
  const changedCost = cents(cost * (1 + scope / 100));
  return { cost, margin, quote, scope, targetPrice: cents(cost / (1 - margin / 100)),
    marginAmount: cents(quote - cost), actualMargin: cents((quote - cost) / quote * 100),
    markup: cents((quote - cost) / cost * 100), changedCost,
    changedTargetPrice: cents(changedCost / (1 - margin / 100)), changedMargin: cents((quote - changedCost) / quote * 100) };
}
export function pricingCsv(result) {
  if (!result) return null;
  return 'measure,value,unit\n' + Object.entries(result).map(([key, value]) => `${key},${value},${['margin','scope','actualMargin','markup','changedMargin'].includes(key) ? 'percent' : 'USD'}`).join('\n') + '\n';
}
